import React from 'react';
import { Card } from '@/components/ui';

interface BoqCostSummaryProps {
  stats: {
    materialShare: number;
    laborShare: number;
    equipmentShare: number;
    subcontractorShare?: number;
  };
}

export function BoqCostSummary({ stats }: BoqCostSummaryProps) {
  return (
    <Card className="p-6">
      <h3 className="font-bold text-slate-900 mb-6 flex items-center gap-2">
        <i className="ri-pie-chart-line text-os-primary" />
        Cơ cấu Chi phí dự toán
      </h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="p-4 bg-blue-50 rounded-2xl border border-blue-100">
          <p className="text-[10px] text-blue-600 font-bold mb-1  tracking-wider">Vật tư</p>
          <p className="text-lg font-bold text-slate-900">{Math.round(stats.materialShare)}%</p>
        </div>
        <div className="p-4 bg-emerald-50 rounded-2xl border border-emerald-100">
          <p className="text-[10px] text-emerald-600 font-bold mb-1  tracking-wider">Nhân công</p>
          <p className="text-lg font-bold text-slate-900">{Math.round(stats.laborShare)}%</p>
        </div>
        <div className="p-4 bg-orange-50 rounded-2xl border border-orange-100">
          <p className="text-[10px] text-orange-600 font-bold mb-1  tracking-wider">Thiết bị</p>
          <p className="text-lg font-bold text-slate-900">{Math.round(stats.equipmentShare)}%</p>
        </div>
        <div className="p-4 bg-purple-50 rounded-2xl border border-purple-100">
          <p className="text-[10px] text-purple-600 font-bold mb-1  tracking-wider">Thầu phụ</p>
          <p className="text-lg font-bold text-slate-900">{Math.round(stats.subcontractorShare || 0)}%</p>
        </div>
      </div>
    </Card>
  );
}
